import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ArrowMinimizeIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='M21.7071 3.70711C22.0976 3.31658 22.0976 2.68342 21.7071 2.29289C21.3166 1.90237 20.6834 1.90237 20.2929 2.29289L16 6.58579L16 4.99999C16 4.44771 15.5523 3.99999 15 4C14.4477 4 14 4.44771 14 5L14 9C14 9.55228 14.4477 10 15 10L19 10C19.5523 10 20 9.55228 20 9C20 8.44772 19.5523 8 19 8L17.4142 8L21.7071 3.70711ZM2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L6.58579 16H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H9C9.55228 14 10 14.4477 10 15L10 19C10 19.5523 9.55229 20 9 20C8.44772 20 8 19.5523 8 19L8 17.4142L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071Z'
        />
    </svg>
));
